import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import styled from 'styled-components'

const StyledImage = styled.img`
    border-radius: 8px;
    width: 100%;
    max-height: 80vh;
    object-fit: fill;
`

interface QuestionImageDialogProps {
    isOpen: boolean
    imgUrl: string
    onClose: () => void
}
export default function QuestionImageDialog({ isOpen, imgUrl, onClose }: QuestionImageDialogProps) {
    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
            <DialogContent>
                <StyledImage src={imgUrl} alt="question" />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Schließen
                </Button>
            </DialogActions>
        </Dialog>
    )
}
